import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/Elements';
import { Head } from '@/components/Head';
import { PublicCleanLayout } from '@/components/Layout';

export type RedirectProps = {
  location: string;
};

export const Redirect = ({ location }: RedirectProps) => {
  useEffect(() => {
    window.location.replace(location);
  }, [location]);

  const { t } = useTranslation();

  return (
    <PublicCleanLayout>
      <Head />
      <div className="max-w-7xl mt-16 m-auto px-4 lg:px-0 text-center">
        <p>{t('common.redirect')}</p>
        <Spinner size="sm" className="inline-block mt-2" />
      </div>
    </PublicCleanLayout>
  );
};
